import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, from, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { RetryLink } from '@apollo/client/link/retry';
import fetch from 'cross-fetch';
import { config } from '../config/env';

const retryLink = new RetryLink();

const perfLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    return response;
  });
});

const errorLink = onError(({ graphQLErrors, networkError, response, operation }) => {
  const { operationName, variables, query } = operation;
  const requestPayload = {
    operationName,
    variables,
    query: query?.loc?.source?.body,
  };
  const responseData = response?.data;

  if (graphQLErrors?.length) {
    graphQLErrors.forEach((error) => {
      const consolePayload = {
        ...(requestPayload || {}),
        response_data: {
          ...(responseData || {}),
        },
        error,
      };
      console.error('GraphQL Error:', error);
      console.error('Console Payload:', consolePayload);
    });
    if (graphQLErrors?.[0].message === 'Unauthorized') {
      authApolloClient.clearStore();
    }
  }

  if (networkError) {
    const consolePayload = {
      ...(requestPayload || {}),
      response_data: {
        ...(responseData || {}),
      },
      networkError,
    };
    console.error('Network Error:', networkError);
    console.error('Console Payload:', consolePayload);
  }
});

const sessionAuthLink = () =>
  setContext(async (_, { headers }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedHeader: Record<string, any> = {
      headers: {
        ...headers,
      },
    };
    return modifiedHeader;
  });
const cache = new InMemoryCache();

const getAuthClient = (uri: string): ApolloClient<NormalizedCacheObject> => {
  const appHeaders: Record<string, string> = {};
  appHeaders['x-app-version-code'] = '1.0.0';
  appHeaders['x-app-version'] = '2.2.0';
  appHeaders['x-device-platform'] = 'ios';

  const appVersionLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      ...appHeaders,
    },
  }));

  const httpLink = new HttpLink({
    uri: uri,
    fetch,
    fetchOptions: {
      timeout: 10000,
    },
  });

  return new ApolloClient({
    uri: uri,
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
    connectToDevTools: process.env.APP_ENV !== 'production',
    link: from([sessionAuthLink(), appVersionLink, perfLink, errorLink, retryLink, httpLink]),
  });
};
const authApolloClient = getAuthClient(config.AUTH_API_ENDPOINT);

export default authApolloClient;
